export default __webpack_public_path__ + "static/white_bg1-4a8b4ddfca1d3b974210bfebf741f1e5.svg";